import styled from 'styled-components'

export const PhoneNumberInput = styled.div`
  width: 100%;
  & > div > input {
    height: 40px !important;
    padding: 9px 9px 9px 45px !important;
  }
`
